(function () {
  'use strict';

  // ═══════════════════════════════════════════════════════════════════════════════
  // KYTE CAR PARTS — FREE GIFT ENGINE v14.0 (EXPLOIT-PROOF)
  // ═══════════════════════════════════════════════════════════════════════════════
  //
  // APPROACH: BOGOS.io / ₹0 gift variant method
  //
  //   OLD (exploitable):
  //     Trigger: MANNOL 7832 1L (₹909)  +  Gift: separate ₹1 SKU  ← customer edits qty
  //
  //   NEW (exploit-proof):
  //     Trigger: MANNOL 7832 1L (₹909)  +  Gift: ₹0.00 ghost variant (FREEGIFT_AUTO discount)
  //     ↳ Even if customer removes trigger, gift = ₹0 so no financial gain
  //     ↳ Server-side webhook auto-cancels invalid orders
  //
  // HOW ₹0 GIFTS WORK:
  //   1. Each gift product has a dedicated ₹0.00 variant in Shopify
  //   2. FREEGIFT_AUTO discount code gives 100% off on these variants
  //   3. Shiprocket sees: MANNOL 7832 1L (100% off) - FREE  ← same as screenshot
  //   4. No manipulation possible: free item already costs ₹0
  //
  // ═══════════════════════════════════════════════════════════════════════════════

  try {

  // ─── GLOBAL CONFIG ────────────────────────────────────────────────────────────

  var GLOBAL_DISCOUNT_CODE = 'FREEGIFT_AUTO_';

  // ─── ALL OFFERS ───────────────────────────────────────────────────────────────
  // Gift variantIds below are the ₹0.00 ghost variants.
  // Create these in Shopify: Products → [gift product] → Add variant → Price: ₹0.00

  var OFFERS = [

    // OFFER 1: Free additive when buying 5L+ car engine oil
    {
      id:               'carOil5L',
      collectionHandle: 'cars-engine-oil',
      minLitres:        5,
      sessionKey:       'freeGiftShown_carOil5L',
      cacheKey:         'engineOilProductIds',
      accentColor:      '#e8a020',
      heading:          "You've unlocked a Free Gift!",
      subheading:       'Choose one free additive — you must select one to continue:',
      excludeVariantIds: [43927436361821],
      gifts: [
        {
          variantId: 44417691222109,  // ← ₹0 ghost variant
          label:     'MANNOL Ceramo Ester 9829 - 350ml',
          image:     'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/mannol9829-350ml.webp?v=1769167563'
        },
        {
          variantId: 44417691615325,  // ← ₹0 ghost variant
          label:     'MANNOL 9991 Molibden Additive - 350ml',
          image:     'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/generated-image_1.webp?v=1768803956'
        }
      ]
    },

    // OFFER 2: BOGO — Buy MANNOL 7722 5L, get 1L free
    {
      id:               'b1g1Mannol7722',
      isBogo:           true,
      triggerVariantId: 43927436361821,
      sessionKey:       'b1g1Mannol7722Shown',
      accentColor:      '#22c55e',
      heading:          'Buy 1 Get 1 Free!',
      subheading:       'Buy 1x MANNOL 7722 Longlife 0W-20 5L and get 1L absolutely free!',
      gifts: [
        {
          variantId: 43927436329053,  // ← ₹0 ghost variant (1L version)
          label:     'MANNOL 7722 Longlife 508/509 0W-20 - 1L (Free)',
          image:     'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/MANNOL_7722_5L_LONGLIFE.webp?v=1768653095'
        }
      ]
    },

    // OFFER 3: Free additive when buying 4L+ car engine oil
    {
      id:               'carOil4L',
      collectionHandle: 'cars-engine-oil',
      minLitres:        4,
      sessionKey:       'freeGiftShown_carOil4L',
      cacheKey:         'engineOilProductIds',
      accentColor:      '#e8a020',
      heading:          "You've unlocked a Free Gift!",
      subheading:       'Choose one free additive — you must select one to continue:',
      gifts: [
        {
          variantId: 44417691680861,  // ← ₹0 ghost variant
          label:     'MANNOL 9900 Motor Flush - 350ml',
          image:     'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/9900.webp?v=1768198476'
        },
        {
          variantId: 44417691254877,  // ← ₹0 ghost variant
          label:     'MANNOL 9930 Diesel Ester Additive - 250ml',
          image:     'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/MN9930_250_F24_1.webp?v=1768816703'
        }
      ]
    },

    // OFFER 4: Free Radiator Flush when buying 5L+ coolant
    {
      id:               'coolant5L',
      collectionHandle: 'coolants-for-bikes-cars-trucks',
      minLitres:        5,
      sessionKey:       'freeGiftShown_coolant5L',
      cacheKey:         'coolantProductIds',
      accentColor:      '#3b82f6',
      heading:          "You've unlocked a Free Gift!",
      subheading:       'Claim your free gift below:',
      gifts: [
        {
          variantId: 44417691189341,  // ← ₹0 ghost variant
          label:     'MANNOL 9965 Radiator Flush - 250ml',
          image:     'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/MANNOL_9965_Radiator_Flush_Universal_COOLANT_System_Cleaner_-1.webp?v=1768819837'
        }
      ]
    },

    // OFFER 5: Free White Grease Spray when buying 2L+ bike oil
    {
      id:               'bikeOil2L',
      collectionHandle: 'bikes-engine-oil',
      minLitres:        2,
      sessionKey:       'freeGiftShown_bikeOil2L',
      cacheKey:         'bikeOilProductIds',
      accentColor:      '#a855f7',
      heading:          "You've unlocked a Free Gift!",
      subheading:       'Claim your free gift below:',
      excludeVariantIds: [44213801812061, 44213480161373, 43927436361821,
                          43927436329053, 44377600688221, 44377601867869],
      gifts: [
        {
          variantId: 44417691156573,  // ← ₹0 ghost variant
          label:     'MANNOL 8121 White Grease Spray - 450ml',
          image:     'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/511WIaIy6JL._SL1200.webp?v=1768825122'
        }
      ]
    },

    // OFFER 6: BOGO — Buy 7832 Powerbike 1L, get 1L free
    {
      id:               'b1g1Powerbike',
      isBogo:           true,
      triggerVariantId: 44213801812061,
      sessionKey:       'b1g1PowerbikeShown',
      accentColor:      '#22c55e',
      heading:          'Buy 1 Get 1 Free!',
      subheading:       'Buy 1L of MANNOL 7832 Powerbike and get another 1L absolutely free!',
      gifts: [
        {
          variantId: 44417708982365,  // ← ₹0 ghost variant
          label:     'MANNOL 7832 Powerbike 15W-50 - 1L (Free)',
          image:     'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/61YpBWeBPrL._SL1200.webp?v=1768816343'
        }
      ]
    },

    // OFFER 7: BOGO — Buy 7814 Motorbike 1L, get 1L free
    {
      id:               'b1g1Motorbike',
      isBogo:           true,
      triggerVariantId: 44213480161373,
      sessionKey:       'b1g1MotorbikeShown',
      accentColor:      '#22c55e',
      heading:          'Buy 1 Get 1 Free!',
      subheading:       'Buy 1L of MANNOL 7814 Motorbike and get another 1L absolutely free!',
      gifts: [
        {
          variantId: 44417691648093,  // ← ₹0 ghost variant
          label:     'MANNOL 7814 Motorbike 10W-50 - 1L (Free)',
          image:     'https://cdn.shopify.com/s/files/1/0687/5332/6173/files/1_2f3d56c8-1d35-4bdc-8179-2b37378b23b0.webp?v=1768802948'
        }
      ]
    }

  ];

  // ─── DERIVED CONSTANTS ────────────────────────────────────────────────────────

  var ALL_GIFT_VARIANT_IDS = (function () {
    var ids = [];
    for (var i = 0; i < OFFERS.length; i++) {
      for (var j = 0; j < OFFERS[i].gifts.length; j++) {
        ids.push(OFFERS[i].gifts[j].variantId);
      }
    }
    return ids;
  }());

  var BOGO_OFFERS   = OFFERS.filter(function (o) { return o.isBogo; });
  var COLLECTION_OFFERS = OFFERS.filter(function (o) { return !o.isBogo; });

  // ─── STATE ────────────────────────────────────────────────────────────────────

  var _internalCartOp  = false;
  var _checkInProgress = false;
  var _debounceTimer   = null;
  var _initDone        = false;
  // _discountApplied removed — discount is re-applied every cycle (Shiprocket fix)
  var _checkoutLocked  = false;
  var _mutationPaused  = false;
  var _collectionCache = {};

  // ─── SESSION / STORAGE HELPERS ────────────────────────────────────────────────

  function sGet(k)    { try { return sessionStorage.getItem(k); }    catch (e) { return null; } }
  function sSet(k, v) { try { sessionStorage.setItem(k, v); }        catch (e) {} }
  function sDel(k)    { try { sessionStorage.removeItem(k); }        catch (e) {} }

  // ─── NUMBER HELPERS ───────────────────────────────────────────────────────────

  function toNum(raw) {
    if (typeof raw === 'number') { return raw; }
    var m = String(raw).match(/(\d+)$/);
    return m ? Number(m[1]) : NaN;
  }

  function parseLitres(val) {
    if (!val) { return 0; }
    var s = String(val).trim();
    var ml = s.match(/^(\d+(?:\.\d+)?)\s*ml$/i);
    if (ml) { return parseFloat(ml[1]) / 1000; }
    var l  = s.match(/^(\d+(?:\.\d+)?)\s*(?:l|ltr|ltrs|litre|litres?)$/i);
    if (l)  { return parseFloat(l[1]); }
    return 0;
  }

  function parseCans(val) {
    if (!val) { return 1; }
    var m = String(val).trim().match(/^(\d+)\s*(?:can|bottle|tin)s?$/i);
    return m ? parseInt(m[1], 10) : 1;
  }

  function calcItemLitres(item) {
    var size = '', numItems = '';
    if (item.options_with_values) {
      item.options_with_values.forEach(function (o) {
        var n = String(o.name || '').toLowerCase().trim();
        if (n === 'size')            { size     = o.value || ''; }
        if (n === 'number of items') { numItems = o.value || ''; }
      });
    }
    if (!size && item.variant_title && item.variant_title.toLowerCase().indexOf('default') === -1) {
      var pts = item.variant_title.split('/');
      size = (pts[0] || '').trim();
      if (pts[1]) { numItems = pts[1].trim(); }
    }
    if (!size && item.title) {
      var tm = item.title.match(/(\d+(?:\.\d+)?)\s*(?:l|ltr|litre|litres?|ml)/i);
      if (tm) { size = tm[0]; }
    }
    return parseLitres(size) * parseCans(numItems) * item.quantity;
  }

  function isGiftVariant(vid) {
    var id = toNum(vid);
    for (var i = 0; i < ALL_GIFT_VARIANT_IDS.length; i++) {
      if (ALL_GIFT_VARIANT_IDS[i] === id) { return true; }
    }
    return false;
  }

  function isFreeGiftLine(item) {
    if (!item.properties) { return false; }
    var props = item.properties;
    if (Array.isArray(props)) {
      return props.some(function (p) { return p.name === '_isFreeGift' && String(p.value) === 'true'; });
    }
    return String(props['_isFreeGift']) === 'true';
  }

  // ─── CART API HELPERS ─────────────────────────────────────────────────────────

  function cartPost(url, body) {
    return fetch(url, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function dispatchCartEvents() {
    ['cart:updated', 'cart:refresh', 'theme:cart:updated'].forEach(function (evt) {
      try { document.dispatchEvent(new CustomEvent(evt)); } catch (e) {}
      try { window.dispatchEvent(new CustomEvent(evt)); }   catch (e) {}
    });
  }

  // ─── DISCOUNT CODE APPLICATION ────────────────────────────────────────────────
  //
  // ROOT CAUSE OF SHIPROCKET BUG:
  //   /discount/ sets a cookie for Shopify's own checkout — Shiprocket ignores it.
  //   The ONLY method Shiprocket reads is the cart-level discount field set via
  //   /cart/update.js { discount: 'CODE' }.
  //
  // FIX:
  //   1. Always call /cart/update.js with the discount — this is what Shiprocket reads.
  //   2. Also call /discount/ as a backup for Shopify native checkout.
  //   3. Remove the one-shot _discountApplied flag — re-apply on every gift claim
  //      because the cart discount field can be lost if the customer changes the cart.

  function applyDiscountToCart() {
    // PRIMARY: /cart/update.js — this is what Shiprocket reads
    return fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ discount: GLOBAL_DISCOUNT_CODE })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      // SECONDARY: /discount/ redirect for Shopify native checkout (fire and forget)
      fetch('/discount/' + encodeURIComponent(GLOBAL_DISCOUNT_CODE), {
        method:      'GET',
        credentials: 'same-origin'
      }).catch(function () {});
      console.log('[KYTE] Discount applied: ' + GLOBAL_DISCOUNT_CODE);
    })
    .catch(function (e) {
      console.warn('[KYTE] Discount apply failed:', e);
    });
  }

  // Keep applyDiscountCode and applyDiscountViaCartUpdate as aliases
  // so all existing call sites work without changes
  function applyDiscountCode() { return applyDiscountToCart(); }
  function applyDiscountViaCartUpdate() { return Promise.resolve(); }

  // ─── COLLECTION FETCHING ──────────────────────────────────────────────────────

  function fetchCollectionIds(handle, cacheKey) {
    if (_collectionCache[cacheKey] && _collectionCache[cacheKey].length) {
      return Promise.resolve(_collectionCache[cacheKey]);
    }
    try {
      var stored = JSON.parse(sessionStorage.getItem(cacheKey));
      if (stored && stored.length) {
        _collectionCache[cacheKey] = stored;
        return Promise.resolve(stored);
      }
    } catch (e) {}

    return fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ids = (d && d.products) ? d.products.map(function (p) { return p.id; }) : [];
        _collectionCache[cacheKey] = ids;
        sSet(cacheKey, JSON.stringify(ids));
        return ids;
      })
      .catch(function () { return []; });
  }

  function invalidateCaches() {
    COLLECTION_OFFERS.forEach(function (o) {
      if (o.cacheKey) {
        delete _collectionCache[o.cacheKey];
        sDel(o.cacheKey);
      }
    });
  }

  // ─── GIFT CART OPERATIONS ─────────────────────────────────────────────────────

  // Add a ₹0 gift variant to cart with free gift properties
  function addGiftToCart(variantId, offerId) {
    _internalCartOp = true;
    return cartPost('/cart/add.js', {
      items: [{
        id:         variantId,
        quantity:   1,
        properties: {
          '_isFreeGift': 'true',
          '_offerId':    String(offerId),
          'Free Gift':   'Yes'   // Visible in Shopify admin / Shiprocket
        }
      }]
    })
    .then(function (r) { _internalCartOp = false; return r; })
    .catch(function (e) { _internalCartOp = false; throw e; });
  }

  // Remove gift variant from cart by variantId
  function removeGiftFromCart(variantId, items) {
    var updates = {};
    var found   = false;
    (items || []).forEach(function (item) {
      if (toNum(item.variant_id) === toNum(variantId) && isFreeGiftLine(item)) {
        updates[item.key] = 0;
        found = true;
      }
    });
    if (!found) { return Promise.resolve(); }
    _internalCartOp = true;
    return cartPost('/cart/update.js', { updates: updates })
      .then(function () { _internalCartOp = false; })
      .catch(function () { _internalCartOp = false; });
  }

  // Clamp gift quantity to 1 (exploit: customer increased qty in Shiprocket)
  function clampGiftQty(variantId, items) {
    var giftLine = null;
    (items || []).forEach(function (item) {
      if (toNum(item.variant_id) === toNum(variantId) && isFreeGiftLine(item)) {
        giftLine = item;
      }
    });
    if (!giftLine || giftLine.quantity <= 1) { return Promise.resolve(); }
    var u = {};
    u[giftLine.key] = 1;
    _internalCartOp = true;
    return cartPost('/cart/update.js', { updates: u })
      .then(function () { _internalCartOp = false; })
      .catch(function () { _internalCartOp = false; });
  }

  // ─── BOGO CART MANAGEMENT ─────────────────────────────────────────────────────
  // For BOGO: gift variant is the ₹0 ghost variant (different ID from trigger).
  // Gift qty must never exceed trigger qty (max 1 free per 1 paid).

  function findGiftLineInCart(giftVariantId, items) {
    var vid = toNum(giftVariantId);
    var found = null;
    (items || []).forEach(function (item) {
      if (toNum(item.variant_id) === vid && isFreeGiftLine(item)) { found = item; }
    });
    return found;
  }

  function findTriggerLineInCart(triggerVariantId, items) {
    var vid = toNum(triggerVariantId);
    var found = null;
    (items || []).forEach(function (item) {
      if (toNum(item.variant_id) === vid && !isFreeGiftLine(item)) { found = item; }
    });
    return found;
  }

  // Self-heal: ensure gift qty === min(1, triggerQty), or remove if trigger gone
  function healBogoGift(offer, items) {
    var triggerLine = findTriggerLineInCart(offer.triggerVariantId, items);
    var gift        = offer.gifts[0];
    var giftLine    = findGiftLineInCart(gift.variantId, items);

    // Trigger removed from cart → remove gift too
    if (!triggerLine || triggerLine.quantity === 0) {
      if (giftLine) {
        var u = {};
        u[giftLine.key] = 0;
        _internalCartOp = true;
        return cartPost('/cart/update.js', { updates: u })
          .then(function () { _internalCartOp = false; dispatchCartEvents(); })
          .catch(function () { _internalCartOp = false; });
      }
      return Promise.resolve();
    }

    var maxGiftQty = 1; // Always 1 free regardless of how many paid
    // (change to triggerLine.quantity to allow N-for-N matching)

    // Gift not in cart → add it
    if (!giftLine) {
      return addGiftToCart(gift.variantId, offer.id)
        .then(function () { return applyDiscountToCart(); })
        .then(function () { dispatchCartEvents(); });
    }

    // Gift qty too high → clamp it
    if (giftLine.quantity > maxGiftQty) {
      var fix = {};
      fix[giftLine.key] = maxGiftQty;
      _internalCartOp = true;
      return cartPost('/cart/update.js', { updates: fix })
        .then(function () { _internalCartOp = false; dispatchCartEvents(); })
        .catch(function () { _internalCartOp = false; });
    }

    return Promise.resolve();
  }

  // ─── POPUP ────────────────────────────────────────────────────────────────────

  function injectStyles() {
    if (document.getElementById('kg-styles')) { return; }
    var css = [
      '.kg-overlay{display:none;position:fixed;inset:0;z-index:2147483640;background:rgba(0,0,0,.88);align-items:center;justify-content:center;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif}',
      '.kg-overlay.kg-active{display:flex}',
      '.kg-modal{background:#13161b;border:1px solid rgba(255,255,255,.08);border-radius:20px;padding:36px 28px 28px;max-width:560px;width:94%;box-shadow:0 32px 80px rgba(0,0,0,.8);animation:kgIn .3s cubic-bezier(.22,.68,0,1.2)}',
      '@keyframes kgIn{from{opacity:0;transform:translateY(24px) scale(.96)}to{opacity:1;transform:translateY(0) scale(1)}}',
      '.kg-tag{display:inline-flex;align-items:center;gap:6px;background:rgba(34,197,94,.12);border:1px solid rgba(34,197,94,.3);color:#22c55e;font-size:.7rem;font-weight:700;letter-spacing:.06em;padding:4px 12px;border-radius:99px;margin:0 auto 14px;text-transform:uppercase}',
      '.kg-tag svg{width:12px;height:12px;fill:currentColor}',
      '.kg-heading{font-size:1.45rem;font-weight:800;color:#fff;margin:0 0 8px;text-align:center;line-height:1.2}',
      '.kg-sub{font-size:.88rem;color:#9ca3af;margin:0 0 24px;text-align:center;line-height:1.5}',
      '.kg-cards{display:flex;flex-wrap:wrap;gap:14px;justify-content:center}',
      '.kg-card{background:#1c1f26;border:2px solid transparent;border-radius:14px;padding:18px 14px;display:flex;flex-direction:column;align-items:center;width:150px;text-align:center;cursor:pointer;transition:border-color .2s,transform .15s}',
      '.kg-card:hover{transform:translateY(-2px)}',
      '.kg-card.kg-selected{border-color:#22c55e;background:#1a2a1f}',
      '.kg-card img{width:120px;height:120px;object-fit:contain;border-radius:8px;margin-bottom:10px}',
      '.kg-free-badge{display:inline-block;background:linear-gradient(135deg,#22c55e,#16a34a);color:#fff;font-size:.65rem;font-weight:800;letter-spacing:.08em;padding:2px 9px;border-radius:99px;margin-bottom:7px;text-transform:uppercase}',
      '.kg-label{font-size:.78rem;color:#d1d5db;line-height:1.35;margin-bottom:14px;flex:1}',
      '.kg-btn{width:100%;padding:10px 0;border:none;border-radius:10px;font-size:.85rem;font-weight:700;cursor:pointer;color:#fff;transition:all .15s;letter-spacing:.02em}',
      '.kg-btn:disabled{background:#2a2d35!important;cursor:not-allowed;opacity:.6}',
      '.kg-btn:not(:disabled):hover{filter:brightness(1.1);transform:translateY(-1px)}',
      '.kg-btn:not(:disabled):active{transform:translateY(0)}',
      '.kg-warn{display:none;color:#f87171;font-size:.8rem;margin-top:14px;text-align:center;padding:8px;background:rgba(248,113,113,.08);border-radius:8px}',
      '.kg-footer{color:#6b7280;font-size:.73rem;margin-top:16px;text-align:center;display:flex;align-items:center;justify-content:center;gap:5px}',
      '.kg-footer svg{width:13px;height:13px;fill:#6b7280}',
      /* Cart UI locking */
      '.kg-locked-item .quantity__button,',
      '.kg-locked-item .cart-item__quantity-button,',
      '.kg-locked-item .cart__qty button,',
      '.kg-locked-item [data-quantity-minus],',
      '.kg-locked-item [data-quantity-plus],',
      '.kg-locked-item .cart-item__remove,',
      '.kg-locked-item .remove,',
      '.kg-locked-item [href*="change"],',
      '.kg-locked-item .cart__remove{display:none!important}',
      '.kg-free-tag{display:inline-flex;align-items:center;gap:4px;background:rgba(34,197,94,.15);border:1px solid rgba(34,197,94,.3);color:#22c55e;font-size:.7rem;font-weight:700;padding:2px 8px;border-radius:99px;margin-left:6px}',
      '.kg-price-free{color:#22c55e;font-weight:700}',
      '.kg-price-orig{text-decoration:line-through;color:#6b7280;margin-right:6px}',
      '@media(max-width:440px){.kg-card{width:calc(50% - 7px)}.kg-card img{width:100%;height:100px}}'
    ].join('');

    var s = document.createElement('style');
    s.id = 'kg-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function buildPopup(offer) {
    var pid = 'kg-popup-' + offer.id;
    if (document.getElementById(pid) || !document.body) { return; }

    var overlay = document.createElement('div');
    overlay.id        = pid;
    overlay.className = 'kg-overlay';

    var modal = document.createElement('div');
    modal.className = 'kg-modal';

    // Tag
    var tag = document.createElement('div');
    tag.className = 'kg-tag';
    tag.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20 7H4c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 11H4V9h16v9zm-8-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>FREE GIFT UNLOCKED';
    modal.appendChild(tag);

    var h = document.createElement('p');
    h.className = 'kg-heading'; h.textContent = offer.heading;
    modal.appendChild(h);

    var sub = document.createElement('p');
    sub.className = 'kg-sub'; sub.textContent = offer.subheading;
    modal.appendChild(sub);

    var cards = document.createElement('div');
    cards.className = 'kg-cards';

    var selectedGift = offer.gifts.length === 1 ? offer.gifts[0] : null;
    var claimBtn     = null;

    offer.gifts.forEach(function (gift) {
      var card = document.createElement('div');
      card.className = 'kg-card';
      if (offer.gifts.length === 1) { card.classList.add('kg-selected'); }

      var img = document.createElement('img');
      img.src = gift.image; img.alt = gift.label; img.loading = 'lazy';
      card.appendChild(img);

      var badge = document.createElement('span');
      badge.className = 'kg-free-badge'; badge.textContent = 'FREE';
      card.appendChild(badge);

      var lbl = document.createElement('p');
      lbl.className = 'kg-label'; lbl.textContent = gift.label;
      card.appendChild(lbl);

      if (offer.gifts.length > 1) {
        var selBtn = document.createElement('button');
        selBtn.type = 'button'; selBtn.className = 'kg-btn';
        selBtn.textContent = 'Select';
        selBtn.style.background = '#374151';
        selBtn.addEventListener('click', function () {
          // Deselect all cards
          cards.querySelectorAll('.kg-card').forEach(function (c) { c.classList.remove('kg-selected'); });
          cards.querySelectorAll('.kg-btn').forEach(function (b) {
            b.textContent = 'Select'; b.style.background = '#374151';
          });
          card.classList.add('kg-selected');
          selBtn.textContent = '✓ Selected';
          selBtn.style.background = offer.accentColor;
          selectedGift = gift;
          if (claimBtn) { claimBtn.disabled = false; }
          var w = document.getElementById('kg-warn-' + offer.id);
          if (w) { w.style.display = 'none'; }
        });
        card.appendChild(selBtn);
      }

      cards.appendChild(card);
    });

    modal.appendChild(cards);

    var warn = document.createElement('p');
    warn.id = 'kg-warn-' + offer.id;
    warn.className = 'kg-warn';
    warn.textContent = offer.gifts.length > 1
      ? 'Please select a gift before continuing'
      : 'Claim your gift to continue';
    modal.appendChild(warn);

    // Main claim button
    claimBtn = document.createElement('button');
    claimBtn.type      = 'button';
    claimBtn.className = 'kg-btn';
    claimBtn.style.cssText = 'background:' + offer.accentColor + ';margin-top:18px;padding:13px 0;font-size:.95rem';
    claimBtn.textContent   = offer.gifts.length > 1 ? 'Claim Selected Gift' : 'Claim Free Gift';
    if (offer.gifts.length > 1) { claimBtn.disabled = true; }

    claimBtn.addEventListener('click', function () {
      if (!selectedGift) {
        var w = document.getElementById('kg-warn-' + offer.id);
        if (w) { w.style.display = 'block'; }
        return;
      }
      claimGift(offer, selectedGift, claimBtn);
    });
    modal.appendChild(claimBtn);

    // Footer
    var footer = document.createElement('p');
    footer.className = 'kg-footer';
    footer.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/></svg>This gift will be packed with your order';
    modal.appendChild(footer);

    overlay.appendChild(modal);

    // Block background click (must select gift)
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        var w = document.getElementById('kg-warn-' + offer.id);
        if (w) { w.style.display = 'block'; }
      }
    });

    document.body.appendChild(overlay);
  }

  function showPopup(offerId) {
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', function () { showPopup(offerId); });
      return;
    }
    var el = document.getElementById('kg-popup-' + offerId);
    if (el) { el.classList.add('kg-active'); }
  }

  function hidePopup(offerId) {
    var el = document.getElementById('kg-popup-' + offerId);
    if (el) { el.classList.remove('kg-active'); }
  }

  // ─── CLAIM GIFT (collection & BOGO) ──────────────────────────────────────────
  // Adds the ₹0 gift variant to cart + applies discount code

  function claimGift(offer, gift, btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Adding gift...'; }

    sSet(offer.sessionKey, 'true');

    // Step 1: Add the ₹0 gift variant to Shopify cart
    addGiftToCart(gift.variantId, offer.id)
      .then(function () {
        // Step 2: Verify the gift actually landed in cart
        // This catches race conditions where add.js returns 200 but cart hasn't updated
        return fetchCart();
      })
      .then(function (cart) {
        var landed = (cart.items || []).some(function (item) {
          return toNum(item.variant_id) === toNum(gift.variantId) && isFreeGiftLine(item);
        });
        if (!landed) {
          console.warn('[KYTE] Gift not found in cart after add — retrying once:', gift.variantId);
          return addGiftToCart(gift.variantId, offer.id);
        }
        console.log('[KYTE] Gift confirmed in cart:', gift.variantId);
        return Promise.resolve();
      })
      .then(function () {
        // Step 3: Apply discount — /cart/update.js {discount} is what Shiprocket reads
        return applyDiscountToCart();
      })
      .then(function () {
        hidePopup(offer.id);
        lockGiftItemsInUI();
        dispatchCartEvents();
        triggerCartRefresh();
        // Step 4: Re-apply discount after cart drawer re-renders
        // Shiprocket re-fetches the cart object on checkout page load
        setTimeout(function () { applyDiscountToCart(); }, 800);
        setTimeout(function () { applyDiscountToCart(); }, 2500);
      })
      .catch(function (err) {
        console.error('[KYTE] claimGift error:', err);
        applyDiscountToCart();
        hidePopup(offer.id);
        dispatchCartEvents();
      });
  }

  // ─── CART UI LOCKING ──────────────────────────────────────────────────────────
  // Hides qty +/- and remove buttons on free gift line items in cart drawer/page.
  // Also shows strikethrough price + FREE label.

  var ITEM_SELECTORS = [
    '.cart-item',
    '.cart__item',
    '.cart-drawer__item',
    '[data-cart-item]',
    'tr.cart__row',
    '.line-item',
    'li.cart-item'
  ].join(',');

  function lockGiftItemsInUI() {
    if (!document.body) { return; }
    _mutationPaused = true;

    // Find all gift variant IDs in the current gift list
    var giftVidStrings = ALL_GIFT_VARIANT_IDS.map(function (v) { return String(v); });

    var items = document.querySelectorAll(ITEM_SELECTORS);
    items.forEach(function (el) {
      var vid = el.getAttribute('data-variant-id')
             || el.getAttribute('data-variant_id')
             || el.getAttribute('data-id')
             || '';

      // Also check for _isFreeGift property marker on hidden inputs
      var freeInput = el.querySelector('input[name="_isFreeGift"]') ||
                      el.querySelector('[data-free-gift]');

      var isGift = giftVidStrings.indexOf(String(vid)) !== -1 || !!freeInput;

      if (isGift) {
        el.classList.add('kg-locked-item');

        // Add FREE badge if not already there
        if (!el.querySelector('.kg-free-tag')) {
          var nameEl = el.querySelector('.cart-item__name, .cart__item-name, .product-option, h3, a');
          if (nameEl) {
            var badge = document.createElement('span');
            badge.className = 'kg-free-tag';
            badge.innerHTML = '&#127873; Free Gift';
            nameEl.appendChild(badge);
          }
        }

        // Strikethrough original price + show FREE
        var priceEl = el.querySelector('.price, .cart-item__price, .money');
        if (priceEl && !el.querySelector('.kg-price-free')) {
          var origText = priceEl.textContent.trim();
          if (origText && origText !== '₹0.00' && origText !== 'Free') {
            var orig = document.createElement('span');
            orig.className = 'kg-price-orig';
            orig.textContent = origText;
            var free = document.createElement('span');
            free.className = 'kg-price-free';
            free.textContent = 'FREE';
            priceEl.textContent = '';
            priceEl.appendChild(orig);
            priceEl.appendChild(free);
          }
        }
      }
    });

    setTimeout(function () { _mutationPaused = false; }, 200);
  }

  // ─── CART REFRESH TRIGGER ─────────────────────────────────────────────────────
  // Calls theme's own cart refresh mechanism if available

  function triggerCartRefresh() {
    // Dawn theme
    if (window.Shopify && window.Shopify.theme) {
      dispatchCartEvents();
    }
    // Some themes expose a global refreshCart function
    if (typeof window.refreshCart === 'function') { window.refreshCart(); }
    if (typeof window.cart_refresh === 'function') { window.cart_refresh(); }
    // Re-run UI lock after a delay to catch re-rendered elements
    setTimeout(lockGiftItemsInUI, 500);
    setTimeout(lockGiftItemsInUI, 1500);
  }

  // ─── BOGO AUTO-MANAGEMENT (runs every check) ──────────────────────────────────

  function checkBogoOffers(items) {
    BOGO_OFFERS.forEach(function (offer) {
      var triggerLine = findTriggerLineInCart(offer.triggerVariantId, items);
      var gift        = offer.gifts[0];
      var giftLine    = findGiftLineInCart(gift.variantId, items);

      // No trigger in cart
      if (!triggerLine) {
        // Clean up any lingering gift
        if (giftLine) {
          var u = {};
          u[giftLine.key] = 0;
          _internalCartOp = true;
          cartPost('/cart/update.js', { updates: u })
            .then(function () {
              _internalCartOp = false;
              sDel(offer.sessionKey);
              dispatchCartEvents();
            })
            .catch(function () { _internalCartOp = false; });
        }
        hidePopup(offer.id);
        sDel(offer.sessionKey);
        return;
      }

      // Trigger present
      if (giftLine) {
        // Gift already in cart — clamp qty to 1
        healBogoGift(offer, items);
        hidePopup(offer.id);
        return;
      }

      // Gift not in cart yet — show popup once
      if (sGet(offer.sessionKey) !== 'true') {
        buildPopup(offer);
        showPopup(offer.id);
      }
    });
  }

  // ─── COLLECTION OFFER CHECK ───────────────────────────────────────────────────

  function checkCollectionOffers(items) {
    // Pre-compute car oil litres (shared across carOil5L and carOil4L)
    var carOilIds = _collectionCache['engineOilProductIds'] || [];
    var carOilExcludes = [];
    COLLECTION_OFFERS.forEach(function (o) {
      if ((o.id === 'carOil5L' || o.id === 'carOil4L') && o.excludeVariantIds) {
        carOilExcludes = carOilExcludes.concat(o.excludeVariantIds);
      }
    });

    var totalCarOilL = 0;
    items.forEach(function (item) {
      if (isGiftVariant(item.variant_id) || isFreeGiftLine(item)) { return; }
      var excl = carOilExcludes.some(function (x) { return toNum(x) === toNum(item.variant_id); });
      if (!excl && carOilIds.indexOf(item.product_id) !== -1) {
        totalCarOilL += calcItemLitres(item);
      }
    });

    COLLECTION_OFFERS.forEach(function (offer) {
      var collIds = _collectionCache[offer.cacheKey] || [];

      var totalL = 0;
      if (offer.id === 'carOil5L' || offer.id === 'carOil4L') {
        totalL = totalCarOilL;
      } else {
        items.forEach(function (item) {
          if (isGiftVariant(item.variant_id) || isFreeGiftLine(item)) { return; }
          var excl = offer.excludeVariantIds &&
            offer.excludeVariantIds.some(function (x) { return toNum(x) === toNum(item.variant_id); });
          if (!excl && collIds.indexOf(item.product_id) !== -1) {
            totalL += calcItemLitres(item);
          }
        });
      }

      var meetsThreshold = totalL >= offer.minLitres;

      // carOil4L superseded by carOil5L if 5L already unlocked
      if (offer.id === 'carOil4L' && totalCarOilL >= 5) {
        // Remove carOil4L gift if present (carOil5L takes over)
        offer.gifts.forEach(function (gift) {
          var giftLine = findGiftLineInCart(gift.variantId, items);
          if (giftLine) {
            var u = {};
            u[giftLine.key] = 0;
            _internalCartOp = true;
            cartPost('/cart/update.js', { updates: u })
              .then(function () { _internalCartOp = false; sDel(offer.sessionKey); dispatchCartEvents(); })
              .catch(function () { _internalCartOp = false; });
          }
        });
        hidePopup(offer.id);
        return;
      }

      if (!meetsThreshold) {
        // Dropped below threshold — remove gift and reset session
        offer.gifts.forEach(function (gift) {
          var giftLine = findGiftLineInCart(gift.variantId, items);
          if (giftLine) {
            var u = {};
            u[giftLine.key] = 0;
            _internalCartOp = true;
            cartPost('/cart/update.js', { updates: u })
              .then(function () { _internalCartOp = false; sDel(offer.sessionKey); dispatchCartEvents(); })
              .catch(function () { _internalCartOp = false; });
          }
        });
        hidePopup(offer.id);
        sDel(offer.sessionKey);
        return;
      }

      // Threshold met — check if gift already in cart
      var giftAlreadyInCart = offer.gifts.some(function (gift) {
        return !!findGiftLineInCart(gift.variantId, items);
      });
      if (giftAlreadyInCart) {
        hidePopup(offer.id);
        // Gift is in cart — ensure discount is still attached (Shiprocket reads this)
        // This silently re-applies on every cycle without blocking anything
        fetch('/cart/update.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ discount: GLOBAL_DISCOUNT_CODE })
        }).catch(function () {});
        return;
      }

      // Show popup once per session
      if (sGet(offer.sessionKey) !== 'true') {
        buildPopup(offer);
        showPopup(offer.id);
      }
    });
  }

  // ─── CHECKOUT GUARD ───────────────────────────────────────────────────────────
  // Before checkout: verify all BOGO gifts still have their trigger in cart.
  // If trigger is gone, remove the gift silently before proceeding.
  // (With ₹0 gifts this is cosmetic — financial exploit is already impossible.)

  function validateBeforeCheckout() {
    return fetchCart().then(function (cart) {
      var items   = cart.items || [];
      var updates = {};
      var needsFix = false;

      BOGO_OFFERS.forEach(function (offer) {
        var triggerLine = findTriggerLineInCart(offer.triggerVariantId, items);
        var gift        = offer.gifts[0];
        var giftLine    = findGiftLineInCart(gift.variantId, items);

        if (!giftLine) { return; }

        if (!triggerLine) {
          // Orphaned gift — remove it
          updates[giftLine.key] = 0;
          needsFix = true;
          console.warn('[KYTE GUARD] Removing orphan gift for:', offer.id);
          return;
        }

        // Clamp gift qty to 1
        if (giftLine.quantity > 1) {
          updates[giftLine.key] = 1;
          needsFix = true;
        }
      });

      // Also clamp all collection gift variants to qty 1
      COLLECTION_OFFERS.forEach(function (offer) {
        offer.gifts.forEach(function (gift) {
          var giftLine = findGiftLineInCart(gift.variantId, items);
          if (giftLine && giftLine.quantity > 1) {
            updates[giftLine.key] = 1;
            needsFix = true;
          }
        });
      });

      if (!needsFix) { return Promise.resolve(); }

      _internalCartOp = true;
      return cartPost('/cart/update.js', { updates: updates })
        .then(function () { _internalCartOp = false; })
        .catch(function () { _internalCartOp = false; });
    });
  }

  function interceptCheckoutButtons() {
    if (window._kyteCheckoutPatched) { return; }
    window._kyteCheckoutPatched = true;

    var BTN_SEL = [
      '[name="checkout"]',
      'button[data-checkout-btn]',
      '.cart__checkout',
      '.cart-drawer__checkout',
      '.cart__cta a',
      '[data-testid="Checkout-button"]',
      '.shopify-payment-button__button',
      'input[type="submit"][name="checkout"]'
    ].join(',');

    var CHECKOUT_RE = /\/checkout|\/checkouts\//;

    function handleCheckout(e, el) {
      if (_checkoutLocked) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      e.preventDefault(); e.stopImmediatePropagation();
      _checkoutLocked = true;

      var origText = '', origVal = '';
      if (el) {
        if (el.tagName === 'INPUT') { origVal = el.value || ''; el.value = 'Preparing...'; el.disabled = true; }
        else if (el.tagName !== 'A') { origText = el.textContent || ''; el.textContent = 'Preparing...'; el.disabled = true; }
      }

      function restore() {
        if (!el) { return; }
        if (el.tagName === 'INPUT') { el.value = origVal; el.disabled = false; }
        else if (el.tagName !== 'A') { el.textContent = origText; el.disabled = false; }
      }

      function proceed() {
        _checkoutLocked = false; restore();
        window.location.href = (el && el.tagName === 'A' && el.href) ? el.href : '/checkout';
      }

      validateBeforeCheckout()
        .then(proceed)
        .catch(function (err) { console.error('[KYTE] Checkout guard error:', err); proceed(); });
    }

    document.addEventListener('click', function (e) {
      var node = e.target;
      while (node && node !== document.documentElement) {
        if (node.matches) {
          if (node.matches(BTN_SEL)) { handleCheckout(e, node); return; }
          if (node.tagName === 'A' && node.href && CHECKOUT_RE.test(node.href)) { handleCheckout(e, node); return; }
        }
        node = node.parentElement;
      }
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.action && CHECKOUT_RE.test(form.action)) {
        if (_checkoutLocked) { e.preventDefault(); return; }
        e.preventDefault();
        _checkoutLocked = true;
        validateBeforeCheckout()
          .then(function () { _checkoutLocked = false; form.submit(); })
          .catch(function () { _checkoutLocked = false; form.submit(); });
      }
    }, true);
  }

  // ─── MAIN CYCLE ───────────────────────────────────────────────────────────────

  function checkAllOffers() {
    if (_internalCartOp || _checkInProgress) { return; }
    _checkInProgress = true;

    // Fetch all needed collection IDs + cart in parallel
    var fetches = [];
    var seen    = {};
    COLLECTION_OFFERS.forEach(function (o) {
      if (o.cacheKey && !seen[o.cacheKey]) {
        seen[o.cacheKey] = true;
        fetches.push(fetchCollectionIds(o.collectionHandle, o.cacheKey));
      }
    });

    Promise.all([Promise.all(fetches), fetchCart()])
      .then(function (results) {
        var items = results[1].items || [];

        if (!_initDone) {
          _initDone = true;
          // Initial: clamp any gift items that may have been manipulated
          items.forEach(function (item) {
            if (isFreeGiftLine(item) && item.quantity > 1) {
              var u = {}; u[item.key] = 1;
              _internalCartOp = true;
              cartPost('/cart/update.js', { updates: u })
                .then(function () { _internalCartOp = false; })
                .catch(function () { _internalCartOp = false; });
            }
          });
        }

        checkBogoOffers(items);
        checkCollectionOffers(items);
        lockGiftItemsInUI();

        // Re-apply discount every cycle whenever any gift is in cart.
        // Runs silently without blocking _internalCartOp so it doesn't
        // interfere with the cart watcher or cause infinite loops.
        var hasGift = items.some(function (item) { return isFreeGiftLine(item) || isGiftVariant(item.variant_id); });
        if (hasGift) {
          // Fire and forget — does not set _internalCartOp
          fetch('/cart/update.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({ discount: GLOBAL_DISCOUNT_CODE })
          }).catch(function () {});
        }
      })
      .catch(function (err) { console.error('[KYTE] checkAllOffers error:', err); })
      .then(function () { _checkInProgress = false; });
  }

  // ─── DEBOUNCE ─────────────────────────────────────────────────────────────────

  var DEBOUNCE_MS = 600;

  function scheduleCheck() {
    if (_internalCartOp) { return; }
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(function () {
      invalidateCaches();
      checkAllOffers();
    }, DEBOUNCE_MS);
  }

  // ─── INTERCEPTS (Fetch + XHR + Events) ───────────────────────────────────────

  var CART_RE = /\/cart\/(add|change|update|clear)/;

  function interceptFetch() {
    if (window._kyteFetchPatched) { return; }
    window._kyteFetchPatched = true;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      return orig.apply(this, arguments).then(function (response) {
        if (CART_RE.test(url) && !_internalCartOp) { scheduleCheck(); }
        return response;
      });
    };
  }

  function interceptXHR() {
    if (window._kyteXHRPatched) { return; }
    window._kyteXHRPatched = true;
    var orig = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (CART_RE.test(url)) {
        this.addEventListener('load', function () {
          if (!_internalCartOp) { scheduleCheck(); }
        });
      }
      return orig.apply(this, arguments);
    };
  }

  function listenCartEvents() {
    var h = function () { scheduleCheck(); };
    ['cart:updated', 'cart:refresh', 'theme:cart:updated'].forEach(function (evt) {
      document.addEventListener(evt, h);
      window.addEventListener(evt, h);
    });
  }

  // ─── MUTATION OBSERVER — re-lock gift items after cart re-renders ─────────────

  function observeDOM() {
    if (!window.MutationObserver || !document.body) { return; }
    var debounce = null;
    var obs = new MutationObserver(function (mutations) {
      if (_mutationPaused) { return; }
      var relevant = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && !n.classList.contains('kg-locked-item');
        });
      });
      if (relevant) {
        clearTimeout(debounce);
        debounce = setTimeout(lockGiftItemsInUI, 150);
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // ─── INIT ─────────────────────────────────────────────────────────────────────

  function init() {
    injectStyles();
    interceptFetch();
    interceptXHR();
    listenCartEvents();

    function ready() {
      observeDOM();
      lockGiftItemsInUI();
      interceptCheckoutButtons();
      checkAllOffers();
      // Periodic watcher every 3 seconds as fallback
      setInterval(function () {
        if (!_internalCartOp && !_checkInProgress) {
          checkAllOffers();
        }
      }, 3000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ready);
    } else {
      ready();
    }
  }

  init();

  } catch (fatalErr) {
    console.error('[KYTE GIFT ENGINE] FATAL:', fatalErr);
  }

}());